import type { GridColDef } from "@mui/x-data-grid-premium";
import type { DecisionContingencyCheckbox_ItemFragment } from "../../doc-items/fields/DecisionContingencyCheckbox.generated.js";
import { DataGridContingencyCheckboxCell } from "../cells/DataGridContingencyCheckboxCell.js";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { ToggleContingencyFn } from "../useContingencyCheckbox.js";
import type { DocDataGridRow } from "../types.js";

interface Options {
  headerName: string;
  canEdit: boolean;
  toggleContingency: ToggleContingencyFn;
}

export function createContingencyCheckboxColumn<
  T extends DocDataGrid_ItemFragment & DecisionContingencyCheckbox_ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "contingencyCheckbox",
    headerName: options.headerName,
    width: 40,
    sortable: false,
    filterable: false,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      const item = params.row.item;
      if (!item.decisionIsContingentItem || item.isItemEliminated) return null;
      return (
        <DataGridContingencyCheckboxCell
          item={item}
          toggleContingency={options.toggleContingency}
          disabled={!options.canEdit}
        />
      );
    },
  };
}
